/**
 * UranIA PA — Segmento layout (amministrazione).
 *
 * Pathless (`id: '_amministrazione'`): raggruppa `/console` e tutto
 * `/admin/*`. Sostituisce la guardia "aggiunta a mano" che viveva dentro
 * il componente di `/console` (rendering condizionale `unauthenticated` /
 * `forbidden`, non un redirect — vedi commit storico `console.tsx`) con
 * un `beforeLoad` sul segmento: chi non è `platform_admin`/`tenant_admin`
 * torna al proprio atterraggio, non a una schermata d'errore (principio
 * §1 del documento di riordino). Le pagine mantengono comunque i loro
 * rami "unauthenticated"/"forbidden" nel componente: restano innocui (mai
 * più raggiunti da una navigazione normale una volta che la guardia sta
 * qui) — non li tocchiamo, fuori ambito per questo passo.
 *
 * Restrizioni più strette di una singola pagina (es. `/admin/tenants`,
 * `/admin/skills*`, `/admin/conformita/gate` riservate a `platform_admin`
 * soltanto, `tenant_admin` escluso) restano come sono oggi, nel
 * componente: la guardia di segmento verifica solo "è un admin qualsiasi
 * ammesso all'area", non quale.
 *
 * Vedi "UranIA PA — Riordino della mappa delle rotte" §3/§5 (2026-09-07),
 * Rilascio A passo A.1.
 */

import { createRoute, Outlet } from '@tanstack/react-router';

import { ruoloCorrente } from '../lib/auth/ruolo-corrente.ts';
import { guardiaAmministrazione } from '../lib/ruoli.ts';
import { Route as RootRoute } from './__root.tsx';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  id: '_amministrazione',
  beforeLoad: () => guardiaAmministrazione(ruoloCorrente()),
  component: Outlet,
});
